import i18n from "i18next";
import { AavoDialogSize } from "src/components/common/dialogs/AavoDialog.tsx";
import { createFormDialogFunction } from "src/components/common/dialogs/formDialog/createFormDialogFunction.ts";
import {
	SalesLeadActivityForm,
	SalesLeadActivityFormProps,
} from "src/components/views/erp/sales/crm/salesLeadActivities/SalesLeadActivityForm.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const SALES_LEAD_ACTIVITY_FORM_DIALOG_TITLE = i18n.t("sales_lead_activity");
export const SALES_LEAD_ACTIVITY_FORM_DIALOG_SIZE: AavoDialogSize = "lg";

export const openSalesLeadActivityFormDialog = createFormDialogFunction<SalesLeadActivityFormProps, number>({
	title: SALES_LEAD_ACTIVITY_FORM_DIALOG_TITLE,
	size: SALES_LEAD_ACTIVITY_FORM_DIALOG_SIZE,
	agentContext: {
		key: defineAgentUiContextKey("erp.sales.salesLeadActivity.formDialog"),
		pathSegments: [SALES_LEAD_ACTIVITY_FORM_DIALOG_TITLE],
	},
	component: SalesLeadActivityForm,
});
